import { Component, useEffect, useRef, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { Button } from 'primereact/button';
import { TabPanel, TabView } from 'primereact/tabview';
import { RadioButton } from 'primereact/radiobutton';

import { TemplateInvoiceService } from '../../../../service/invoice/TemplateInvoiceService';
import { RegisterInvoiceService } from '../../../../service/invoice/RegisterInvoiceService';

import { InvoicePreviewAssets } from '../../../../config';

import { isBusinessLocationTemplate, Menu1 } from './Menu-1';
import { Menu2 } from './Menu-2';
import { Menu3 } from './Menu-3';

import { ToastService } from '../../../../AppToast';
import { ConfirmDialogService } from '../../../../AppConfirmDialog';

import { BusinessLocationService } from '../../../danh-muc/dia-diem-kinh-doanh/BusinessLocationService';
import { InvoiceField } from '../../../hoa-don/item/Initial';
import { useTranslation } from '../../../../shared/language';

const Modify = ({ attribute, changeAttribute, update }) => {
  const { t } = useTranslation();

  const preview = useRef(null);

  const { id } = useParams();
  const { search } = useLocation();

  const [isCopy, setIsCopy] = useState(false);

  const [activeIndex, setActiveIndex] = useState(0);
  const [invoiceTemplateId, setInvoiceTemplateId] = useState(null);
  const [previewSyncToken, setPreviewSyncToken] = useState(0);
  const [templateMutationToken, setTemplateMutationToken] = useState(0);
  const [previewListRefreshToken, setPreviewListRefreshToken] = useState(0);

  useEffect(() => {
    if (search) {
      const params = new URLSearchParams(search);
      setIsCopy(params.get('copy') === 'Y');
    }
  }, [search]);

  const loadAttribute = () => {
    let event: any;
    event = new CustomEvent('getCss', {
      detail: {
        selector: '.songNgu', property: 'display', callback: (value) => {
          changeAttribute('songNgu', value !== 'none');
        }
      }
    });
    dispatchEvent(event);
    event = new CustomEvent('getCss', {
      detail: {
        selector: '.chinhSua.dp-tc', property: 'color', callback: (value) => {
          changeAttribute('colorValue', value);
        }
      }
    });
    dispatchEvent(event);
    event = new CustomEvent('getCss', {
      detail: {
        selector: '#vong1', property: 'font-size', callback: (value) => {
          changeAttribute('fontSize', parseInt(value));
        }
      }
    });
    dispatchEvent(event);
    event = new CustomEvent('getCss', {
      detail: {
        selector: '.thongTinNguoiMua .chinhSua.value', property: 'border-width', callback: (value) => {
          changeAttribute('gachChan', parseInt(value) !== 0);
        }
      }
    });
    dispatchEvent(event);
    event = new CustomEvent('getCss', {
      detail: {
        selector: 'tbody .bordermo1', property: 'border-bottom', callback: (value) => {
          changeAttribute('dongKe', value !== 'none');
        }
      }
    });
    dispatchEvent(event);
    event = new CustomEvent('getCss', {
      detail: {
        selector: '.bordermo1', property: 'border-bottom', callback: (value) => {
          if (value && value.includes('dashed')) {
            changeAttribute('borderStyle', 'dashed');
          } else {
            changeAttribute('borderStyle', 'solid');
          }
        }
      }
    });
    dispatchEvent(event);
    event = new CustomEvent('getCss', {
      detail: {
        selector: '#sd-kh', property: 'display', callback: (value) => {
          changeAttribute('kyHieuCot', value !== 'none');
        }
      }
    });
    dispatchEvent(event);
    event = new CustomEvent('getCss', {
      detail: {
        selector: '#qrcode', property: 'display', callback: (value) => {
          changeAttribute('useBarcode', value !== 'none');
        }
      }
    });
    dispatchEvent(event);
    event = new CustomEvent('getCss', {
      detail: {
        selector: '#base64QRCode', property: 'width', callback: (value) => {
          changeAttribute('qrCodeSize', parseInt(value));
        }
      }
    });
    dispatchEvent(event);
    event = new CustomEvent('getCss', {
      detail: {
        selector: '.logo-img', property: 'display', callback: (value) => {
          changeAttribute('useLogo', value !== 'none');
        }
      }
    });
    dispatchEvent(event);
    event = new CustomEvent('getCss', {
      detail: {
        selector: '.logo-img', property: 'width', callback: (value) => {
          changeAttribute('logoSize', parseInt(value));
        }
      }
    });
    dispatchEvent(event);
    event = new CustomEvent('getCss', {
      detail: {
        selector: '#vong3', property: 'display', callback: (value) => {
          changeAttribute('useBackgroundLogo', value !== 'none');
        }
      }
    });
    dispatchEvent(event);
    event = new CustomEvent('getCss', {
      detail: {
        selector: '#vong3', property: 'width', callback: (value) => {
          changeAttribute('backgroundSize', parseInt(value));
        }
      }
    });
    dispatchEvent(event);
    event = new CustomEvent('getCss', {
      detail: {
        selector: '#vong4', property: 'display', callback: (value) => {
          changeAttribute('useBordersBackground', value !== 'none');
        }
      }
    });
    dispatchEvent(event);

    event = new CustomEvent('setText', {
      detail: { selector: `[databind='TaxAuthorityCode']`, value: '' }
    });
    dispatchEvent(event);
  }

  useEffect(() => {
    if (id) {
      let promise;
      if (update) {
        promise = RegisterInvoiceService.get(id);
      } else {
        promise = TemplateInvoiceService.get(id);
        setInvoiceTemplateId(id);
      }
      promise.then((data) => {
        if (update) {
          setInvoiceTemplateId(data.invoiceTemplateId);
          changeAttribute('originInvoiceType', data.invoiceType);
          changeAttribute('originSymbolCode', data.symbolCode);
          changeAttribute('tenantInvoiceSettingMasterId', data.tenantInvoiceSettingMasterId);
          changeAttribute('signOnly', data.signOnly);
          changeAttribute('formatHtml', data.formatHtml);
        }
        changeAttribute('typeCompany', data.typeCompany);
        changeAttribute('businessLocationId', data.businessLocationId ?? data.businessLocation ?? null);
        changeAttribute('pageSize', data.pageSize || data.tenantRegisterTemplateDto.pageSize);
        let numberRecord = 5;
        if (data.tenantRegisterTemplateDto && data.tenantRegisterTemplateDto.numberRecord) {
          numberRecord = data.tenantRegisterTemplateDto.numberRecord;
        } else if (data.numberRecord) {
          numberRecord = data.numberRecord;
        }
        changeAttribute('numberRecord', numberRecord);

        let numberRecordMutile = 20;
        if (data.tenantRegisterTemplateDto && data.tenantRegisterTemplateDto.numberRecordMutile) {
          numberRecordMutile = data.tenantRegisterTemplateDto.numberRecordMutile;
        } else if (data.numberRecordMutile) {
          numberRecordMutile = data.numberRecordMutile;
        }
        changeAttribute('numberRecordMutile', numberRecordMutile);

        preview.current.contentWindow.document.open();
        if (data.fileContent.includes('id="template-preview"')) {
          preview.current.contentWindow.document.write(`${data.fileContent.trim()}`);
        } else {
          preview.current.contentWindow.document.write(`${data.fileContent.trim()}${InvoicePreviewAssets}`);
        }
        setTimeout(() => {
          loadAttribute();
          setPreviewSyncToken((n) => n + 1);
        }, 1000);
      });
    }
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  const dispatchEvent = (event) => {
    preview.current.contentWindow.document.getElementById('template-preview')?.dispatchEvent(event);
  }

  /** Đồng bộ preview địa điểm KD — đặt ở Modify vì TabView có thể unmount Menu1 khi đang ở Menu3. */
  useEffect(() => {
    let cancelled = false;

    const scheduleMenu3ReloadFromDom = () => {
      queueMicrotask(() => {
        if (!cancelled) {
          setPreviewListRefreshToken((n) => n + 1);
        }
      });
    };

    const emit = (fieldKey: string, value: string) => {
      dispatchEvent(
        new CustomEvent('setText', {
          detail: { selector: `[databind='${fieldKey}']`, value }
        })
      );
    };

    const clearAll = () => {
      emit(InvoiceField.businessLocationCode, '');
      emit(InvoiceField.businessLocationName, '');
      emit(InvoiceField.businessLocationAddress, '');
    };

    const locId = attribute.businessLocationId;
    if (locId == null || locId === '') {
      clearAll();
      scheduleMenu3ReloadFromDom();
      return () => {
        cancelled = true;
      };
    }

    BusinessLocationService.get(locId)
      .then((data: { code?: string | null; name?: string | null; address?: string | null }) => {
        if (cancelled) {
          return;
        }
        emit(InvoiceField.businessLocationCode, data.code ?? '');
        emit(InvoiceField.businessLocationName, data.name ?? '');
        emit(InvoiceField.businessLocationAddress, data.address ?? '');
        scheduleMenu3ReloadFromDom();
      })
      .catch(() => {
        if (cancelled) {
          return;
        }
        clearAll();
        scheduleMenu3ReloadFromDom();
      });

    return () => {
      cancelled = true;
    };
  }, [attribute.businessLocationId, previewSyncToken, templateMutationToken]); // eslint-disable-line react-hooks/exhaustive-deps

  const bumpTemplateMutation = () => {
    setTemplateMutationToken((n) => n + 1);
  };

  const onTabChange = (e) => {
    setActiveIndex(e.index);
    let event;
    if (e.index === 2) {
      event = new CustomEvent('removeClass', {
        detail: { selector: '.tr-cl', value: 'non-selectable' }
      });
      dispatchEvent(event);

      event = new CustomEvent('addClass', {
        detail: { selector: '.tr-cl', value: 'selectable' }
      });
      dispatchEvent(event);
    } else {
      event = new CustomEvent('removeClass', {
        detail: { selector: '.tr-cl', value: 'selectable' }
      });
      dispatchEvent(event);

      event = new CustomEvent('addClass', {
        detail: { selector: '.tr-cl', value: 'non-selectable' }
      });
      dispatchEvent(event);
    }
  }

  const onInvoiceClassChange = (value) => {
    changeAttribute('invoiceClass', value);

    let event;
    switch (value) {
      case '1':
        event = new CustomEvent('setCss', {
          detail: { selector: '#header-child-hd-chuyendoi', property: 'display', value: 'none' }
        });
        dispatchEvent(event);
        event = new CustomEvent('setCss', {
          detail: { selector: '#header-child-hd-dientu', property: 'display', value: 'block' }
        });
        dispatchEvent(event);
        break;
      case '2':
        event = new CustomEvent('setCss', {
          detail: { selector: '#header-child-hd-chuyendoi', property: 'display', value: 'block' }
        });
        dispatchEvent(event);
        event = new CustomEvent('setCss', {
          detail: { selector: '#header-child-hd-dientu', property: 'display', value: 'none' }
        });
        dispatchEvent(event);
        break;
    }
  }

  const reloadTemplate = () => {
    ConfirmDialogService.confirm(t('common.restoreTemplate'), t('common.restoreTemplateQuestion'), () => {
      preview.current.contentWindow.document.open();
      TemplateInvoiceService.get(invoiceTemplateId).then((data) => {
        if (data.fileContent.includes('id="template-preview"')) {
          preview.current.contentWindow.document.write(`${data.fileContent.trim()}`);
        } else {
          preview.current.contentWindow.document.write(`${data.fileContent.trim()}${InvoicePreviewAssets}`);
        }
        setTimeout(() => {
          loadAttribute();
          setPreviewSyncToken((n) => n + 1);
        }, 1000);
      });
    });
  }

  const back = () => {
    window.location.hash = '/phat-hanh/mau-hoa-don';
  }

  const print = () => {
    const myWindow = window.open();
    myWindow.document.open('text/plain');
    myWindow.document.write(preview.current.contentWindow.document.documentElement.outerHTML);
    myWindow.document.close();
    myWindow.onafterprint = myWindow.close;
    myWindow.print();
  }

  const save = () => {
    let event = new CustomEvent('removeClass', {
      detail: { selector: '.tr-cl', value: 'clClickChon-tr' }
    });
    dispatchEvent(event);

    if (invoiceTemplateId && attribute.invoiceType && attribute.invoiceType.id && attribute.symbolCode
      && preview.current.contentWindow.document.documentElement.outerHTML) {

      const previewTag = preview.current.contentWindow.document.getElementById('template-preview');
      if (previewTag) {
        previewTag.remove();
      }

      let fileContent = new XMLSerializer().serializeToString(preview.current.contentWindow.document.documentElement);
      fileContent = fileContent.replace(InvoicePreviewAssets, '');
      fileContent = fileContent.replace('<!--?xml version="1.0" encoding="utf-8"?-->', '');
      fileContent = fileContent.replace('xmlns="http://www.w3.org/1999/xhtml" ', '');
      // console.log(fileContent);
      const data: any = {
        invoiceTemplateId,
        invoiceType: attribute.invoiceType.id,
        invoiceForm: '' + attribute.invoiceType.type,
        symbolCode: attribute.symbolCode,
        invoiceYear: attribute.mauSo3,
        signOnly: attribute.signOnly,
        formatHtml: attribute.formatHtml,
        fileContent,
        typeCompany: attribute.typeCompany,
        businessLocationId: isBusinessLocationTemplate(attribute) ? (attribute.businessLocationId ?? null) : null,
        tenantInvoiceSettingMasterId: attribute.tenantInvoiceSettingMasterId,
        use: true,
        tenantRegisterTemplate: {
          multiLanguage: attribute.songNgu ? 'C' : 'K',
          colorText: attribute.colorText,
          fontStyle: attribute.fontStyle,
          fontSize: attribute.fontSize + 'px',
          useBarcode: attribute.useBarcode,
          useLogo: attribute.useLogo,
          useBackgroundLogo: attribute.useBackgroundLogo,
          useBordersBackground: attribute.useBordersBackground,
          numberRecord: attribute.numberRecord,
          numberRecordMutile: attribute.numberRecordMutile,
          signOnly: attribute.signOnly,
          formatHtml: attribute.formatHtml
        },
        tenantInvoiceSettingDtos: [
          {
            "fieldName": "a",
            "lable": "a",
            "dataType": "",
            "required": true,
            "maxLength": 0,
            "fomat": "",
            "numberItemInLine": 0,
            "readOnly": true,
            "formula": "",
            "groupTypeCode": "A",
            "orders": 0
          }
        ]
      };
      if (!isCopy && update) {
        data.tenantRegisterTemplate.registerInvoiceId = id;
        RegisterInvoiceService.update(id, data)
          .then(() => {
            ToastService.success();
            window.location.reload();
          })
          .catch((err: unknown) => {
            ToastService.error(err);
          });
      } else {
        RegisterInvoiceService.create(data)
          .then((created) => {
            ToastService.success();
            window.location.href = `/#/phat-hanh/mau-hoa-don/update/${created.id}`;
          })
          .catch((err: unknown) => {
            ToastService.error(err);
          });
      }
    } else {
      ToastService.error(t('common.invalidData'));
    }
  }

  const windowHeight = window.innerHeight;

  return (
    <div style={{ width: '1350px', margin: '0 auto' }}>
      <div className="grid">
        <div className="col" style={{ marginRight: '3px' }}>
        </div>
        <div className="col-fixed" style={{ width: '840px' }}>
          <div className="grid">
            <div className="col-12 md:col-4">
              <div className="field-radiobutton mb-0 mt-2">
                <RadioButton inputId="invoiceClass1" name="invoiceClass" value="1" checked={attribute.invoiceClass === '1'} onChange={e => onInvoiceClassChange(e.value)} />
                <label htmlFor="invoiceClass1">{t('templatePreview.electronicInvoiceTemplate')}</label>
              </div>
            </div>
            <div className="col-12 md:col-4">
              <div className="field-radiobutton mb-0 mt-2">
                <RadioButton inputId="invoiceClass2" name="invoiceClass" value="2" checked={attribute.invoiceClass === '2'} onChange={e => onInvoiceClassChange(e.value)} />
                <label htmlFor="invoiceClass2">{t('templatePreview.convertedInvoiceTemplate')}</label>
              </div>
            </div>
            <div className="col-12 md:col-4">
              <Button icon="pi pi-replay" label={t('common.restoreDefault')} className="p-button-outlined p-button-warning p-button-sm" onClick={reloadTemplate} />
            </div>
          </div>
        </div>
      </div>
      <div className="grid">
        <div className="surface-card col" style={{ marginRight: '3px' }}>
          <TabView className="tabview-panels-scroll" activeIndex={activeIndex} onTabChange={onTabChange}>
            <TabPanel header={t('common.generalInfo')}>
              <div className="iam-scroll" style={{ height: (windowHeight - 298) + 'px', overflow: 'hidden auto' }}>
                <Menu1 attribute={attribute} changeAttribute={changeAttribute} dispatchEvent={dispatchEvent} update={update} />
              </div>
            </TabPanel>
            <TabPanel header={t('common.logoBackground')}>
              <div className="iam-scroll" style={{ height: (windowHeight - 298) + 'px', overflow: 'hidden auto' }}>
                <Menu2 attribute={attribute} changeAttribute={changeAttribute} dispatchEvent={dispatchEvent} />
              </div>
            </TabPanel>
            <TabPanel header={t('common.detailCustomization')}>
              <Menu3 attribute={attribute} windowHeight={windowHeight} preview={preview} dispatchEvent={dispatchEvent} onAfterTemplateFieldSave={bumpTemplateMutation} previewListRefreshToken={previewListRefreshToken} />
            </TabPanel>
          </TabView>

          <div className="grid mt-1">
            <div className="col-12 text-center pb-0 mt-2">
              <Button label={t('common.back')} icon="pi pi-arrow-left" className="p-button-outlined p-button-secondary p-button-sm mr-2" onClick={back} />
              <Button label={t('common.printView')} icon="pi pi-print" className="p-button-outlined p-button-secondary p-button-sm mr-2" onClick={print} />
              <Button label={t('common.saveInfo')} icon="pi pi-check" className="p-button-outlined p-button-sm" onClick={save} />
            </div>
          </div>
        </div>
        <div className="surface-card col-fixed iam-scroll" style={{ width: '840px', height: (windowHeight - 180) + 'px', overflow: 'hidden auto' }}>
          <iframe className="template-preview" ref={preview} title="template-preview" />
        </div>
      </div>
    </div>
  );
}

export class ModifyComponent extends Component<any, any> {

  constructor(props) {
    super(props);

    this.state = {
      item: {
        invoiceClass: '1',
        colorText: '#000000',
        fontStyle: 'Time New Roman',
        numberRecord: 10,
        numberRecordMutile: 20,
        mauSo2: 'C',
        mauSo3: '',
        mauSo4: 'T',
        mauSo5: 'YY',
        symbolCode: '',
        useBarcode: true,
        useLogo: true,
        useBackgroundLogo: true,
        useBordersBackground: true,
        qrCodeSize: 10,
        logoSize: 10,
        backgroundSize: 10,
        signOnly: false,
        formatHtml: false,
        typeCompany: 0,
        businessLocationId: null,
      }
    };

    this.setItem = this.setItem.bind(this);
  }

  setItem(key, value) {
    this.setState(prevState => ({
      item: {
        ...prevState.item,
        [key]: value
      }
    }))
  }

  render() {
    return <Modify attribute={this.state.item} changeAttribute={this.setItem} update={this.props.update} />;
  }

}
